import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        boxShadow: 'none',
        textAlign: 'center',
        background: 'none'
    }
});

export const styleNotFount = {
    paddingRight: '100px'
};

export const styleReset = {
    paddingRight: '24px'
};

export const styleName = {
    width: '321px'
};

export type Classes = WithStyles<typeof styles>
